import { Layout } from '@/components/layout/Layout';
import { useAuth } from '@/hooks/use-auth';
import ProductsSnapshotExport from '@/components/ProductsSnapshotExport';

const InventorySnapshots = () => {
  const { companyId } = useAuth();

  if (!companyId) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <p className="text-muted-foreground">Şirket bilgisi bulunamadı</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mx-auto py-6">
        <ProductsSnapshotExport companyId={companyId} />
      </div>
    </Layout>
  );
};

export default InventorySnapshots;
